import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";

const StatCell = ({ k, v, color = "text-cyber-yellow" }) => (
  <div className="hard-border p-6 bg-cyber-surface">
    <div className="term-label">{k}</div>
    <div className={`font-display font-black text-5xl mt-3 tracking-tighter ${color}`}>{v}</div>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentRsvps, setRecentRsvps] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
    api.get("/admin/rsvps", { params: { status_filter: "pending" } }).then(({ data }) => setRecentRsvps(data.slice(0, 5)));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="term-label">/ overview</div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl mt-2">Control room.</h1>
        </div>
        <div className="font-mono-tech text-xs text-white/40">/ {new Date().toISOString()}</div>
      </div>

      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          <StatCell k="/ events" v={String(stats.total_events).padStart(2, '0')} />
          <StatCell k="/ published" v={String(stats.published_events).padStart(2, '0')} />
          <StatCell k="/ rsvps" v={String(stats.total_rsvps).padStart(2, '0')} />
          <StatCell k="/ pending" v={String(stats.pending_rsvps).padStart(2, '0')} color="text-cyber-yellow" />
          <StatCell k="/ approved" v={String(stats.approved_rsvps).padStart(2, '0')} color="text-cyber-green" />
          <StatCell k="/ rejected" v={String(stats.rejected_rsvps).padStart(2, '0')} color="text-cyber-red" />
        </div>
      )}

      <div className="mt-10">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-display font-black tracking-tighter text-2xl">Pending review</h2>
          <Link to="/admin/rsvps" className="font-mono-tech text-xs text-cyber-yellow tracking-[0.2em] uppercase hover:underline">All RSVPs →</Link>
        </div>
        <div className="hard-border">
          <div className="grid grid-cols-12 gap-2 px-5 py-3 border-b border-cyber-line bg-cyber-elevated font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/60">
            <div className="col-span-4">Name / email</div>
            <div className="col-span-3">Event</div>
            <div className="col-span-3">Submitted</div>
            <div className="col-span-2 text-right">Action</div>
          </div>
          {recentRsvps.length === 0 && <div className="px-5 py-6 text-white/50 font-mono-tech text-sm">/ inbox empty.</div>}
          {recentRsvps.map((r) => (
            <div key={r.id} className="grid grid-cols-12 gap-2 px-5 py-4 border-b border-cyber-line items-center" data-testid={`pending-row-${r.id}`}>
              <div className="col-span-4">
                <div className="text-white">{r.name}</div>
                <div className="font-mono-tech text-xs text-white/50">{r.email}</div>
              </div>
              <div className="col-span-3 font-mono-tech text-xs text-white/70">{r.event_title}</div>
              <div className="col-span-3 font-mono-tech text-xs text-white/50">{new Date(r.created_at).toLocaleString()}</div>
              <div className="col-span-2 text-right">
                <Link to="/admin/rsvps" className="font-mono-tech text-xs text-cyber-yellow tracking-[0.2em] uppercase">Review →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
